import { render } from "./SelectAllDistributor.vue?vue&type=template&id=2b79e8ce"
import script from "./SelectAllDistributor.vue?vue&type=script&lang=js"
export * from "./SelectAllDistributor.vue?vue&type=script&lang=js"
script.render = render

export default script